/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAddressV1Dto } from '../models/CreateAddressV1Dto';
import type { CreateCustomerV1Dto } from '../models/CreateCustomerV1Dto';
import type { CustomerToAddressV1Dto } from '../models/CustomerToAddressV1Dto';
import type { CustomerV1Dto } from '../models/CustomerV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchCustomerV1Dto } from '../models/PatchCustomerV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomersService {
  /**
   * @param requestBody
   * @returns CustomerV1Dto create entity
   * @throws ApiError
   */
  public static customerControllerV1CreateV1(
    requestBody: CreateCustomerV1Dto,
  ): CancelablePromise<CustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/customers',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns CustomerV1Dto a entity list
   * @throws ApiError
   */
  public static customerControllerV1FindAllV1(): CancelablePromise<Array<CustomerV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/customers',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static customerControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customers',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid customerId
   * @returns CustomerV1Dto the entity
   * @throws ApiError
   */
  public static customerControllerV1FindOneV1(uuid: string): CancelablePromise<CustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/customers/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid customerId
   * @param requestBody
   * @returns CustomerV1Dto the update entity
   * @throws ApiError
   */
  public static customerControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchCustomerV1Dto,
  ): CancelablePromise<CustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/customers/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @deprecated
   * @param uuid customerId
   * @param requestBody
   * @returns CustomerV1Dto the update entity
   * @throws ApiError
   */
  public static customerControllerV1UpdateV1(
    uuid: string,
    requestBody: PatchCustomerV1Dto,
  ): CancelablePromise<CustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/customers/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid customerId
   * @returns CustomerV1Dto the entity
   * @throws ApiError
   */
  public static customerControllerV1RemoveOneV1(uuid: string): CancelablePromise<CustomerV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customers/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param customerUuid customerId
   * @param requestBody
   * @returns CustomerToAddressV1Dto create entity
   * @throws ApiError
   */
  public static customerToAddressControllerV1CreateAddressV1(
    customerUuid: string,
    requestBody: CreateAddressV1Dto,
  ): CancelablePromise<CustomerToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/customers/{customerUuid}/address',
      path: {
        customerUuid: customerUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param customerUuid customerId
   * @param addressUuid addressId
   * @returns CustomerToAddressV1Dto create entity
   * @throws ApiError
   */
  public static customerToAddressControllerV1LinkAddressV1(
    customerUuid: string,
    addressUuid: string,
  ): CancelablePromise<CustomerToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/customers/{customerUuid}/address/{addressUuid}',
      path: {
        customerUuid: customerUuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param customerUuid customerId
   * @param addressUuid addressId
   * @returns CustomerToAddressV1Dto the entity
   * @throws ApiError
   */
  public static customerToAddressControllerV1UnlinkAddressV1(
    customerUuid: string,
    addressUuid: string,
  ): CancelablePromise<CustomerToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customers/{customerUuid}/address/{addressUuid}',
      path: {
        customerUuid: customerUuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param customerUuid customerId
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static customerToAddressControllerV1RemoveManyAddressesV1(
    customerUuid: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/customers/{customerUuid}/addresses',
      path: {
        customerUuid: customerUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
